import { CustomSpinner } from "components/dashboard/widgets/WidgetBox";

export default function ReportLoadingChart() {
    return (
        <section className="report-empty-chart">
            <CustomSpinner animation="border" />
        </section>
    );
}
